import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { makeAuthService } from 'src/data/services/auth/auth-service-factory';
import { makeJwtService } from '../../data/services/common/jwt/jwt-service-factory';
import { makeTranslateService } from '../../data/services/common/translate/translate-service-factory';
import { makeRouterService } from '../../data/services/view/router/router-service-factory';
import { CommonComponentsModule } from '../components/common/common-components.module';
import { SuperComponent } from '../helpers/super-component';
import { PipesModule } from '../pipes/pipes.module';
import { EntitySelectionService } from './service/entity-selection.service';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DialogModule,
    RippleModule,
    SelectModule,
    PipesModule,
    CommonComponentsModule,
  ],
})
export class AppTopBarComponent extends SuperComponent implements OnInit {
  public readonly logoutConfirmationKey = 'logout';
  public routerService = makeRouterService();
  public authService = makeAuthService();
  public jwtService = makeJwtService();
  public translateService = makeTranslateService();
  public userName = 'Usuário';
  public userEmail = '';

  @ViewChild('menubutton') menuButton!: ElementRef;

  constructor(
    public injector: Injector,
    public layoutService: LayoutService,
    public entitySelectionService: EntitySelectionService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {
    try {
      const token = await this.authService.getToken();
      const decodedToken = this.jwtService.getDataFromToken(token);
      this.userName = decodedToken?.name;
      this.userEmail = decodedToken?.email;
    } catch (error) {
      console.log('AppTopBarComponent.ngOnInit > error', error);
    }

    await this.entitySelectionService.initialize();
    this.detectChanges();
  }

  async logout() {
    this.confirmationService.confirm({
      key: this.logoutConfirmationKey,
      message: '',
      closeOnEscape: true,
      icon: '',
      header: this.translateService.translateKey(
        this.languageKey.DO_YOU_WANT_TO_EXIT,
      ),
      acceptLabel: this.translateService.translateKey(this.languageKey.YES),
      rejectLabel: this.translateService.translateKey(this.languageKey.NO),
      accept: async () => {
        try {
          this.authService.logout();
        } catch (error) {
          await this.logService.error('AppTopBarComponent.logout -> ', error);
        }
      },
    });
  }
  async openMyAccount(): Promise<void> {
    await this.routerService.navigate(['/home']);
  }

  openHelp(): void {
    this.messageService.add({
      severity: 'info',
      summary: 'Ajuda',
      detail: 'Canal de ajuda em configuracao.',
    });
  }
}
